import React, { useMemo } from 'react';
import { styled } from '@mui/material';
import { List, ListSubheader } from '@mui/material';
import StatusListItem from 'components/MeasurementDates/components/RolloverStatus/components/status-list-item/StatusListItem';
import { useMDContext } from 'context/MDContext';
import { classes, Root } from './RolloverStatus.styles';



const RolloverStatus = () => {
  const { items: fundItems, statusList, subItems: companyItems } = useMDContext();

  const fundIdNameMap = useMemo(
    () =>
      fundItems.reduce(
        (acc, item) => ({
          ...acc,
          [item.id as number]: item.name,
        }),
        {} as { [key: number]: string }
      ),
    [fundItems]
  );

  const companyIdNameMap = useMemo(
    () =>
      companyItems.reduce(
        (acc, companyItem) => ({
          ...acc,
          [companyItem.id]: companyItem.name,
        }),
        {} as { [key: number]: string }
      ),
    [companyItems]
  );

  return (
    <Root className={classes.container}>
      {statusList?.fundResult?.length !== 0 && (
        <span>
          <List
            subheader={
              <ListSubheader disableSticky>
                <strong>Funds</strong>
              </ListSubheader>
            }>
            {fundIdNameMap
              && statusList.fundResult.map((fund, index) => (
                <StatusListItem key={fund.key} item={fund} index={index} idNameMap={fundIdNameMap} />
              ))}
          </List>
          <br />
        </span>
      )}
      {statusList.companyResult?.length !== 0 && (
        <List
          subheader={
            <ListSubheader disableSticky>
              <strong>Companies</strong>
            </ListSubheader>
          }>
          {companyIdNameMap
            && statusList.companyResult.map((company, index) => (
              <StatusListItem key={company.key} item={company} index={index} idNameMap={companyIdNameMap} />
            ))}
        </List>
      )}
    </Root>
  );
};

export default RolloverStatus;
